import a from "./rgbToHsl";
import b from "./roundTo4Dp";
export default (function (c) {
  var d = 6 > c.length,
      e = d ? c.substr(1).match(/.{1}/g) : c.substr(1).match(/.{2}/g);
  d && (e = e.map(function (a) {
    return a + a;
  }));
  var f = e.map(function (a) {
    return parseInt(a, 16);
  }),
      g = a(f[0], f[1], f[2]);
  return {
    h: g[0],
    s: g[1],
    l: g[2],
    a: f[3] ? b(f[3] / 255) : 1
  };
});